import { useState, useCallback } from "react";

// Recuerda las URLs de imágenes que fallaron al cargar (corruptas o inexistentes),
// para mostrar en su lugar el placeholder de "sin imagen".
export function useBrokenImages() {
  const [brokenUrls, setBrokenUrls] = useState(() => new Set());

  const markBroken = useCallback((url) => {
    if (!url) return;
    setBrokenUrls(prev => (prev.has(url) ? prev : new Set(prev).add(url)));
  }, []);

  // true si hay URL y cargó (o aún no ha fallado)
  const hasImage = useCallback((url) => !!url && !brokenUrls.has(url), [brokenUrls]);

  return { hasImage, markBroken };
}
